var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container search" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c("div", { staticClass: "row flex-column-reverse flex-sm-row" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6 text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { to: "/co2-emissions" }
                    },
                    [
                      _vm._v(
                        "\n                            Back to List\n                        "
                      )
                    ]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("messages", { attrs: { messages: _vm.messages } }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-8" }, [
                _c("div", { staticClass: "card" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.importCsv.apply(null, arguments)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "csv_file" } }, [
                            _vm._v("CSV File")
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            ref: "fileInput",
                            staticClass: "form-control-file",
                            attrs: {
                              type: "file",
                              id: "csv_file",
                              accept: ".csv,.txt",
                              disabled: _vm.importing
                            },
                            on: { change: _vm.onFileSelected }
                          }),
                          _vm._v(" "),
                          _c("small", { staticClass: "form-text text-muted" }, [
                            _vm._v(
                              "\n                                            Maximum file size: 10MB. Accepted formats: .csv, .txt\n                                        "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.errors.csv_file
                            ? _c("div", { staticClass: "text-danger mt-1" }, [
                                _vm._v(
                                  "\n                                            " +
                                    _vm._s(_vm.errors.csv_file[0]) +
                                    "\n                                        "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _vm.selectedFile
                          ? _c("div", { staticClass: "mb-3" }, [
                              _c("strong", [_vm._v("Selected file:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.selectedFile.name) +
                                  "\n                                        "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c("strong", [_vm._v("Size:")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatFileSize(_vm.selectedFile.size)
                                  ) +
                                  "\n                                    "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("div", { staticClass: "form-check" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.clearDatabase,
                                  expression: "clearDatabase"
                                }
                              ],
                              staticClass: "form-check-input",
                              attrs: {
                                type: "checkbox",
                                id: "clear_database",
                                disabled: _vm.importing
                              },
                              domProps: {
                                checked: Array.isArray(_vm.clearDatabase)
                                  ? _vm._i(_vm.clearDatabase, null) > -1
                                  : _vm.clearDatabase
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.clearDatabase,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.clearDatabase = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.clearDatabase = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.clearDatabase = $$c
                                    }
                                  },
                                  _vm.confirmClearDatabase
                                ]
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label",
                                attrs: { for: "clear_database" }
                              },
                              [
                                _vm._v(
                                  "\n                                                Clear existing CO2 emissions data before importing\n                                            "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.clearDatabase
                            ? _c(
                                "small",
                                { staticClass: "form-text text-danger" },
                                [
                                  _c("i", {
                                    staticClass: "fa fa-exclamation-triangle"
                                  }),
                                  _vm._v(" "),
                                  _c("strong", [_vm._v("Warning:")]),
                                  _vm._v(
                                    " This will permanently delete all existing CO2 emissions data in the database.\n                                        "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary",
                            attrs: {
                              type: "submit",
                              disabled: !_vm.selectedFile || _vm.importing
                            }
                          },
                          [
                            _vm.importing
                              ? _c("span", [
                                  _c("i", {
                                    staticClass: "fa fa-spinner fa-spin mr-2"
                                  }),
                                  _vm._v(
                                    "\n                                            Importing...\n                                        "
                                  )
                                ])
                              : _c("span", [
                                  _c("i", { staticClass: "fa fa-upload mr-2" }),
                                  _vm._v(
                                    "\n                                            Import CSV\n                                        "
                                  )
                                ])
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.importing
                      ? _c("div", { staticClass: "mt-3" }, [_vm._m(2)])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.importResults
                      ? _c("div", { staticClass: "mt-4" }, [
                          _vm.importResults.queued
                            ? _c("div", { staticClass: "alert alert-info" }, [
                                _vm._m(3),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(_vm._s(_vm.importResults.message))
                                ]),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "\n                                            The import is running in the background.\n                                        "
                                  )
                                ])
                              ])
                            : _c("div", { staticClass: "alert alert-info" }, [
                                _c("h6", [_vm._v("Import Results")]),
                                _vm._v(" "),
                                _c("p", [
                                  _c("strong", [_vm._v("Records imported:")]),
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.importResults.imported_count)
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.importResults.error_count > 0
                                  ? _c("p", [
                                      _c("strong", [_vm._v("Errors:")]),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.importResults.error_count
                                          ) +
                                          "\n                                        "
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                          _vm._v(" "),
                          _vm.importResults.errors &&
                          _vm.importResults.errors.length > 0
                            ? _c(
                                "div",
                                { staticClass: "alert alert-warning" },
                                [
                                  _c("h6", [_vm._v("Import Errors")]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    {
                                      staticClass: "mb-0",
                                      staticStyle: {
                                        "max-height": "200px",
                                        "overflow-y": "auto"
                                      }
                                    },
                                    _vm._l(_vm.importResults.errors, function(
                                      error,
                                      index
                                    ) {
                                      return _c("li", { key: index }, [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(error) +
                                            "\n                                            "
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._m(4)
            ])
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("h2", [_vm._v("Import CO2 Emissions")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Upload CSV File")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "progress" }, [
      _c(
        "div",
        {
          staticClass:
            "progress-bar progress-bar-striped progress-bar-animated",
          staticStyle: { width: "100%" },
          attrs: { role: "progressbar" }
        },
        [
          _vm._v(
            "\n                                            Processing...\n                                        "
          )
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h6", [
      _c("i", { staticClass: "fa fa-clock-o mr-2" }),
      _vm._v("Import Queued")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("h6", [_vm._v("CSV Format Requirements")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c("p", [_c("strong", [_vm._v("Expected columns (in order):")])]),
          _vm._v(" "),
          _c("ol", { staticClass: "small" }, [
            _c("li", [_vm._v("Chassis number")]),
            _vm._v(" "),
            _c("li", [_vm._v("Make")]),
            _vm._v(" "),
            _c("li", [_vm._v("Model")]),
            _vm._v(" "),
            _c("li", [_vm._v("Year")]),
            _vm._v(" "),
            _c("li", [_vm._v("Industry Code")]),
            _vm._v(" "),
            _c("li", [_vm._v("Variant")]),
            _vm._v(" "),
            _c("li", [_vm._v("Class")]),
            _vm._v(" "),
            _c("li", [_vm._v("Tare")]),
            _vm._v(" "),
            _c("li", [_vm._v("Engine type")]),
            _vm._v(" "),
            _c("li", [_vm._v("CC rating")]),
            _vm._v(" "),
            _c("li", [_vm._v("Transmission")]),
            _vm._v(" "),
            _c("li", [_vm._v("Test cycle")]),
            _vm._v(" "),
            _c("li", [_vm._v("Current emission standard")]),
            _vm._v(" "),
            _c("li", [_vm._v("CO₂ 3PWLTP")]),
            _vm._v(" "),
            _c("li", [_vm._v("CCS weight")]),
            _vm._v(" "),
            _c("li", [_vm._v("CO₂ difference (2024)")]),
            _vm._v(" "),
            _c("li", [_vm._v("CO₂ difference (2025)")]),
            _vm._v(" "),
            _c("li", [_vm._v("CO₂ difference notes")]),
            _vm._v(" "),
            _c("li", [_vm._v("Fleet Average charge (2024)")]),
            _vm._v(" "),
            _c("li", [_vm._v("Fleet Average charge (2025)")]),
            _vm._v(" "),
            _c("li", [_vm._v("Fleet Average rate")]),
            _vm._v(" "),
            _c("li", [_vm._v("Pay As You Go charge (2024)")]),
            _vm._v(" "),
            _c("li", [_vm._v("Pay As You Go charge (2025)")]),
            _vm._v(" "),
            _c("li", [_vm._v("Pay As You Go rate")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "alert alert-info small" }, [
            _c("strong", [_vm._v("Note:")]),
            _vm._v(
              " The first row should contain column headers and will be skipped during import.\n                                "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0906e7b3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0906e7b3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Co2Emissions/Import.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0906e7b3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Co2Emissions/Import.vue
// module chunks = 0